<template>
  <Modal hide-footer>
    <Image
      :media="item.itinerary_image"
      conversion="cover"
      responsive
      :alt="item.title"
    />
  </Modal>
</template>

<script setup lang="ts">
import type { ItineraryBlock } from '~/types/blocks'

defineProps<{
  item: ItineraryBlock
}>()
</script>
